module.exports = __webpack_public_path__ + "img/mylev-nav.e25e5b9f.svg";